import { DEFAULT_INPUT_PREFIX } from './constants';

export const cleanInputLabel = (label: string): string => {
  return label.split(DEFAULT_INPUT_PREFIX).slice(-1)[0];
};

export const cleanNullableInputLabel = (label: Nullable<string>): string | undefined => {
  if (label == null) return undefined;
  const cleanedLabel = cleanInputLabel(label).trim();
  return cleanedLabel.length > 0 ? cleanedLabel : undefined;
};
